<template>
  <q-select
    outlined
    dense
    v-model="selected"
    hide-dropdown-icon
    :options="[]"
    option-value="id"
    option-label="label"
    :placeholder="placeholder"
    :readonly="disabled"
    bg-color="white"
    :options-dense="true"
    class="col-auto myFieldSelect"

    use-input
    use-chips
    multiple
    @new-value="createValue"
  >
    <template #prepend>
      <div
        style="font-size: 0.5em; margin-top: 0;"
        class="col-auto"
      >
        {{ label || value }}:
      </div>
    </template>

    <template #selected>
      <q-chip
        v-for="item in selected"
        :key="item.id"
        outline
        square
        size="0.8em"
        color="primary"
        class="row items-center"
        style="margin: 0 8px 0 0; padding: 2px 8px"
      >
        <div class="col">
          {{ item.id }}
        </div>

        <div
          v-if="!disabled"
          class="col-auto q-pl-xs"
          @click="handleRemove(item)"
        >
          x
        </div>
      </q-chip>
    </template>
  </q-select>
</template>

<script>
export default {
  props: {
    value: {},
    label: {},
    configs: {},
    disabled: {},
    placeholder: {}
  },

  data () {
    const selected = Array.isArray(this.value) ? clone(this.value) : []
    return { selected }
  },

  methods: {
    createValue (val, done) {
      const email = String(val || '').toLowerCase().trim()
      const validEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

      const isValidEmail = email.match(validEmail)
      if (!isValidEmail) return

      const emails = Array.isArray(this.selected) ? this.selected.map(({ id }) => id) : []
      if (emails.includes(email)) return

      done({ id: email, label: email })
    },

    handleRemove (item) {
      const selected = Array.isArray(this.selected) ? [...this.selected] : []
      const indexOf = selected.findIndex(({ id }) => id === item.id)
      if (indexOf === -1) return
      selected.splice(indexOf, 1)
      this.selected = selected
    }
  },

  watch: {
    selected (newSelected) {
      const value = Array.isArray(this.value) ? clone(this.value) : []
      const selected = Array.isArray(newSelected) ? clone(newSelected) : []
      if (isEqual(value, selected)) return
      this.$emit('input', selected)
    },

    value (newValue) {
      const value = Array.isArray(newValue) ? clone(newValue) : []
      const selected = Array.isArray(this.selected) ? clone(this.selected) : []
      if (isEqual(value, selected)) return
      this.selected = value
    }
  }
}

const isEqual = (source, target) => (
  JSON.stringify(source) === JSON.stringify(target)
)

const clone = (source) => (
  JSON.parse(JSON.stringify(source))
)

</script>

<style lang="sass">
.myFieldSelect
  .q-field__control
    min-height: 32px !important
    color: #4c8ec5 !important
    .q-field__control-container
      font-style: normal
      font-weight: normal
      font-size: 13px
      line-height: 18px
      color: rgba(38,50,56, 0.9)

    &:hover
      &:before
        border: 1px solid #486e8e !important
        transition: none

    &:after
      border-width: 1px !important

  .q-field__control-container
    padding-top: 1px
    .q-field__native
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      min-height: 32px

  .q-field__marginal
    height: 32px

  .fontChips
    div.ellipsis
      font-style: normal
      font-weight: normal
      font-size: 12px
      margin-right: 5px

  .q-field__native.row.items-center
    padding: 3px 0 4px 0 !important

  .q-chip
    margin-top: 2px !important
    margin-bottom: 2px !important
    margin-left: 0 !important

  .font-item
    font-style: normal
    font-weight: normal
    font-size: 13px
    line-height: 18px
    color: #263238

.borderUnSelected div.q-checkbox__bg
  border: 1px solid #9E9E9E !important

</style>
